import React from 'react'
import RozcestnikImage from '../../../assets/images/front/rozcestnik-pk-bg.png'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import Reviews from '../../../components/Front/Reviews/Reviews'
import experienceIcon from '../../../assets/images/front/svg/experience.svg'
import individualIcon from '../../../assets/images/front/svg/individual.svg'
import effectiveIcon from '../../../assets/images/front/svg/efective.svg'
import lecturersIcon from '../../../assets/images/front/svg/lectors.svg'

const PkAll: React.FC = () => {
  const history = useHistory()

  return (
    <>
      <div className="relative container mx-auto px-4 mt-[52px] md:mt-0 flex flex-col-reverse md:flex-col bg-[#F5FAFF] md:bg-transparent">
        <img src={RozcestnikImage} alt="" className="w-full h-full object-cover hidden md:block" />
        <div className="grid px-4 lg:px-0 grid-cols-12 gap-4 my-8 md:my-0 top-0 left-0 text-white text-center md:absolute md:top-[200px] md:left-[50%] md:translate-x-[-50%] w-full max-w-[720px] mx-auto">
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#0183BA] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">5. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg">
              <span
                className="cursor-pointer w-full text-center block rounded-lg  py-1 bg-white text-xl text-black font-myriad font-semibold hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk5Online)}
              >
                Online
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#00A0E3] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">7. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg">
              <span
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black py-1 font-myriad font-semibold hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk7Online)}
              >
                Online
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#A8CD00] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">9. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg mb-2">
              <span
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
                onClick={() => history.push(routesURLs.pk9Online)}
              >
                Online
              </span>
            </div>

            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] rounded-lg">
              <span
                onClick={() => history.push(routesURLs.pk9)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Prezenčně
              </span>
            </div>
          </div>
        </div>
        <h1 className="md:absolute md:top-[110px] md:left-[50%] md:translate-x-[-50%] text-center text-[#0183BA] mt-5 -mb-5 md:mt-0 md:mb-0">
          Přípravné kurzy
        </h1>
      </div>
      <img src={RozcestnikImage} alt="" className="w-full h-full object-cover md:hidden -mt-14" />
      <div className="HP">
        <Reviews />
        <div className="px-4 lg:px-0">
          <div className="container mt-[30px] md:mt-[60px] px-4">
            <div className="max-w-[720px] mx-auto">
              <p className="text-center mb-10">
                Naše přípravné kurzy na přijímací zkoušky Cermat z matematiky a českého jazyka
                probíhají v malých skupinách, aby měl každý žák prostor na individuální přístup a
                zpětnou vazbu. Kurzy zahrnují cílenou přípravu na přijímačky, procvičování všech
                typů úloh Cermat, taktiku řešení a trénink časového limitu. Vedle prezenčních kurzů
                nabízíme také online přípravné kurzy. Jedná se o komplexní přípravu na přijímačky,
                nikoliv pouze o zkoušky nanečisto.
              </p>
              <div className="grid grid-cols-12">
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={experienceIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Více než 10 let <br />
                    zkušeností
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={individualIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Individuální <br />
                    přístup
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={effectiveIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Nejefektivnější <br />
                    vyučovací metody
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={lecturersIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Několik desítek <br />
                    zkušených lektorů
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PkAll
